import React from 'react';
import { toast } from 'sonner';
import { useAuthStore } from '@/stores/authStore';
import { useLoginViewModel } from '../view-models/LoginViewModel';
import { ROUTES, TIME_DURATION } from '@/constants';
import { ILoginVariables } from '@/domain/auth/entities';
import { DataResponse } from '@/common/Response';
import { IChangeProfileVariables } from '@/domain/user/entities';
import userService from '@/services/UserService';
import { useProfileStore } from '@/stores/profileStore';
import { useRouter } from 'next/navigation';
import { useLocalStorage } from 'react-use';
import { STORAGE_KEY } from '@/constants/keys';

export function useLoginCRUD() {
  const router = useRouter();

  const { setValAuth, setValProfile } = useProfileStore();
  const [_, setEmailNotYetVerify] = useLocalStorage<string>(
    STORAGE_KEY.EMAIL_NOT_VERIFY,
  );
  const { setAccessToken } = useAuthStore();

  const [isVisible, setIsVisible] = React.useState(false);
  const [isDisabled, setIsDisabled] = React.useState(false);

  const toggleVisibility = () => setIsVisible(prev => !prev);

  const lolignFail = (val: string = '', code = '', data: any = {}) => {
    // toast.error(val ?? 'Login failure', { duration: TIME_DURATION });
    setIsDisabled(prev => !prev);
    if (code === 'DATA_NOT_ACTIVATED_ERR' && data?.email) {
      setEmailNotYetVerify(data.email);
      router.push(ROUTES.signup.path);
    }
  };

  const { login } = useLoginViewModel({
    onSuccess: async (_data: any) => {
      const { token } = _data;
      if (token) {
        setValAuth(_data);

        const responseUser: DataResponse<IChangeProfileVariables> =
          await userService.getProfileMe();
        const { data } = responseUser;
        if (data) {
          setValProfile(data);
        }

        toast.success('Login success', { duration: TIME_DURATION });
        setAccessToken(token);
        router.push('/bank-accounts');
      } else lolignFail();
    },
    onError: (_error: any, _data) => {
      let valErr: string = '';
      let codeError = '';
      if (_error) {
        valErr = `${_error?.message}`;
        codeError = `${_error?.code}`;
      }
      lolignFail(valErr, codeError, _data);
    },
  });

  const onLogin = (valuesUserLogin: ILoginVariables) => {
    setIsDisabled(prev => !prev);
    login(valuesUserLogin);
  };

  return {
    onLogin,
    isVisible,
    toggleVisibility,
    isDisabled,
  };
}
